import React from "react";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { $t } from "~/i18n.js";
import { clubHasFlight } from "~/featureMatrix.jsx";
import { BetaTag } from "~/components/atom/BetaTag.jsx";
import { DropdownMenu } from "~/components/menu/DropdownMenu.jsx";

export function MobileMenu({
  renderHeadless = false,
  showCheckDataButton = false,
  triggerShowCheckModal = () => {},
  profile = {},
  club = {},
}) {
  
  const showMenuVliegend = profile?.vliegt || profile?.group_keys?.includes("niet_vliegend")

  const menuItems = [
    // Work data button
    profile?.vliegt && showCheckDataButton && {
      label: (
        <Button onClick={triggerShowCheckModal} style={{ margin: 12 }}>
          {$t("Werk gegevens bij")}
        </Button>
      ),
    },
    
    // First divider
    (profile?.vliegt && showCheckDataButton) && {type: 'divider'},

    // Registration and reservations
    (profile?.zichzelf_aanmelden || profile?.iedereen_aanmelden) && {
      label: (
        <Link to="/register">{$t("Aanmeldlijst")}</Link>
      ),
    },
    
    clubHasFlight() && (profile?.zichzelf_aanmelden || profile?.iedereen_aanmelden) && {
      label: (
        <Link to="/reservations">{$t("Reserveren")}</Link>
      ),
    },

    // Flight administration
    clubHasFlight() && (showMenuVliegend || profile?.wijzig_start) && {
      label: (
        <Link to="/start">{$t("Startadministratie")}</Link>
      ),
    },
    
    clubHasFlight() && profile?.wijzig_sleep && {
      label: (
        <Link to="/tow">{$t("Sleepadministratie")}</Link>
      ),
    },
    
    profile?.ziet_dto && profile.zichzelf_aanmelden && {
      label: (
        <Link to="/dailyreport">{$t("Dagverslagen")}</Link>
      ),
    },
    
    profile?.zichzelf_aanmelden && {
      label: (
        <Link to="/rosters">{$t("Roosters")}</Link>
      ),
    },

    // Second divider
    {type: 'divider'},

    // Material and reports
    clubHasFlight() && (showMenuVliegend || profile?.iedereen_aanmelden) && {
      label: (
        <Link to="/material">{$t("Materieel")}</Link>
      ),
    },
    
    clubHasFlight() && (showMenuVliegend || profile?.iedereen_aanmelden) && {
      label: (
        <Link to="/report">{$t("Meldingen")}</Link>
      ),
    },
    
    clubHasFlight() && (profile?.wijzig_winteruren || profile?.goedkeuren_uren) && {
      label: (
        <Link to="/maintenancehours">{$t("Onderhoudsuren")}</Link>
      ),
    },

    // Third divider
    {type: 'divider'},

    // General menu items
    {
      label: (
        <Link to="/members">{$t("Ledenlijst")}</Link>
      ),
    },
    
    profile?.ziet_dto && {
      label: (
        <Link to="/dto">{$t("DTO lijst")}</Link>
      ),
    },
    
    profile?.ziet_emaillijst && {
      label: (
        <Link to="/email">{$t("Email")}</Link>
      ),
    },
    
    profile?.wijzig_news && {
      label: (
        <Link to="/news">{$t("Nieuws")}</Link>
      ),
    },

    {
      label: (
        <Link to="/documents">{$t("Documenten")}</Link>
      ),
    },

    profile?.wijzig_findings && {
      label: (
        <Link to="/findings">{$t("Bevindingen")}</Link>
      ),
    },

    // Admin section
    profile?.ziet_staff && {type: 'divider'},

    profile?.ziet_staff && clubHasFlight() && {
      label: (
        <Link to="/admin/flights">{$t("Vluchten")}</Link>
      ),
    },

    profile?.ziet_staff && profile?.wijzig_leden && {
      label: (
        <Link to="/admin/users">{$t("Gebruikers")}</Link>
      ),
    },
    
    profile?.ziet_staff && profile?.wijzig_leden && {
      label: (
        <Link to="/admin/groups">{$t("Groepen")}</Link>
      ),
    },
    
    profile?.ziet_staff && profile?.wijzig_dto && {
      label: (
        <Link to="/admin/dto_settings">{$t("Bevoegdheden")}</Link>
      ),
    },

    profile?.ziet_staff && profile?.wijzig_financial && {
      label: (
        <Link to="/admin/financial">{$t("Financieel")} <BetaTag/></Link>
      ),
    },

    profile?.ziet_staff && {
      label: (
        <Link to="/admin/settings">{$t("Club Settings")}</Link>
      ),
    },

    // Incident reporting button
    club && club?.voorval_link && {
      label: (
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href={club?.voorval_link}
          style={{ margin: 12 }}
        >
          {$t("Meld voorval")}
        </Button>
      ),
    },

  ].filter(f => f);

  return (
    <div className={`mobileMenu ${renderHeadless ? "headlessMobileMenu" : "blueBackground"}`}>
      <DropdownMenu 
        trigger={<MenuOutlined style={{ fontSize: 20, color: renderHeadless ? 'black' : 'white' }} />}
        items={menuItems}
        alignLeft={renderHeadless ? false : true}
        maxHeight="75vh"
      />
    </div>
  );
}
